import {Yii} from "libraries/interfaces/Yii";

const LOADERS = {
    loadingSms: Yii.t('wui-sasha-js', 'Chargement en cours'),
    loadingSendSms: Yii.t('wui-sasha-js', 'Envoi en cours')
};

const CARD_LABELS = {
    header: Yii.t('wui-sasha-js', 'Validation des sms'),
    previousFolder: Yii.t('wui-sasha-js', 'Dossier précédent'),
    nextFolder: Yii.t('wui-sasha-js', 'Dossier suivant'),
    previousView: Yii.t('wui-sasha-js', 'Retour à la saisie'),
    validate: Yii.t('wui-sasha-js', 'Envoyer'),
    currentFolder: Yii.t('wui-sasha-js', 'Dossier'),
    characters: Yii.t('wui-sasha-js', 'Nombre de caractères'),
    numberOfSms: Yii.t('wui-sasha-js', 'Nombre de SMS'),
    replyTo: Yii.t('wui-sasha-js', 'Destinataires'),
    recipient: Yii.t('wui-sasha-js', 'par destinataire'),
    numberOfRecipient: Yii.t('wui-sasha-js', 'Nombre de destinataires')
};

const EMAIL = {
    subject: Yii.t('wui-sasha-js', 'Objet :')
};

export const WORDING = {
    ...CARD_LABELS,
    ...EMAIL,
    ...LOADERS
};